import React, {FC} from "react";
import {Box} from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import clsx from "clsx";
import DefaultLogoSupplier from "view/images/DefaultLogoSupplier";
import DefaultLogoOrganiser from "view/images/DefaultLogoOrganiser";
import FileIcon from "view/components/FileIcon";
import PoweredByTitle from "view/components/PoweredByTitle";
import {sanitizeHtml} from "view/components/SafeHtml";
import {PaymentReminderPreviewData} from "ts/app/payment-reminder/preview-payment-reminder.constraint";
import useStyles from "./styles";

const PaymentReminderEmailBody: FC<PaymentReminderPreviewData> = ({
  greeting,
  body,
  supplierLogoUrl,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.card}>
      <Box className={classes.logos}>
        <Box className={classes.logoBox}>
          <DefaultLogoOrganiser />
        </Box>
        <Box className={clsx(classes.logoBox, classes.logoBoxSupplier)}>
          {supplierLogoUrl ? (
            <img src={supplierLogoUrl} alt="" className={classes.logoImg} />
          ) : (
            <DefaultLogoSupplier />
          )}
        </Box>
      </Box>

      {greeting ? <Box className={classes.greeting}>{greeting}</Box> : null}

      <Box className={classes.bodyCard}>
        {body ? (
          <Box
            className={classes.body}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: sanitizeHtml(body)}}
          />
        ) : null}

        <Box className={classes.invoiceOuter}>
          <Box className={classes.invoiceRow}>
            <Box className={classes.fileIcon}>
              <FileIcon extension="pdf" />
            </Box>
            <span className={classes.fileSize}>PDF, 5MB</span>
            <span className={classes.fileName}>Invoice.pdf</span>
            <OpenInNewIcon className={classes.newTab} />
          </Box>
        </Box>
      </Box>

      <Box className={classes.ctaWrapper}>
        <span className={classes.cta}>View on portal</span>
      </Box>

      <Box className={classes.footer}>
        <Box className={classes.disclaimer}>
          As this is a system-generated email, responses will not be monitored -
          please do not reply.
          <br />
          This email is intended solely for the recipient. Please do not forward
          or share it.
        </Box>
        <PoweredByTitle />
      </Box>
    </Box>
  );
};

export default PaymentReminderEmailBody;
